<template>
  <div id="locations-list">
    <div v-if="devices && devices.items && devices.items.length === 0" class="tooltip-holder">
        <div class="tooltip tooltip--full tooltip--none"><p>No Devices Found</p></div>
    </div>
    <tc-table v-if="devices && devices.items && devices.items.length > 0"
        :dataList="devices"
        :tbody="tbody"
        :settings="{
          externalFilters: {
            show: false
          }
        }">

        <template slot="thead">
            <vs-th sort-key="name">Device Name</vs-th>
            <vs-th sort-key="location">Location</vs-th>
            <vs-th sort-key="code">Device Code</vs-th>
            <vs-th>Actions</vs-th>
        </template>

    </tc-table>
    <vs-button
      v-if="$hasPermission('edit:locations')"
      class="ml-auto mt-4"
      @click="$router.push('add-device')"
      icon-pack="feather"
      icon="icon-plus"
      icon-before>Add New Device</vs-button>
  </div>
</template>

<script>

import devicesTableBody from '@/components/tc-toble-body/Devices.vue';

export default {
  data () {
    return {
      tbody: {
        component: devicesTableBody
      },
      checkBox1: true,
      checkBox2: true,
      selected: [],
      // products: [],
      itemsPerPage: 10,
      isMounted: false,
      //isDataFetched:false,
      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {},
      devices:{}
    };
  },
  computed: {
    /*devices () {
      console.log ('==computed devices==',this.$store.state.visitManagement.devices)
      return this.$store.state.visitManagement.devices;
    },*/
    currentPage () {
      if (this.isMounted) {
        return this.devices.paging.page;
      }
      return 0;
    },
    //products() {
    //  return this.$store.state.dataList.products
    //},
    queriedItems () {
      return this.$refs.table
        ? this.$refs.table.queriedResults.length
        : this.devices.items.length;
    }
  },
  methods: {
    checkOut () {},
    saveChanges () {},
  },
  mounted () {
    this.isMounted = true;
  },
  async created () {
    await Promise.all([
      this.$store.dispatch('visitManagement/fetchDevices', { limit: 1000 }),
    ]);
    this.devices = this.$store.state.visitManagement.devices;
  }
};
</script>
